export const NotificationEndpoints = {
  List: '/v3/notification',
  UnreadCount: '/v3/notification/unSeen/count'
} as const
